import { create } from "zustand";
import { persist } from "zustand/middleware";

// Create the Zustand store
export const useAppStore = create(
  persist(
    (set) => ({
      isSidebarLTPortalCollapse: false,
      setSidebarLTPortalCollapse: (sidebarLTPortalCollapse) =>
        set((_state) => ({
          isSidebarLTPortalCollapse: sidebarLTPortalCollapse,
        })),
      isSidebarCollapse: false,
      setSidebarCollapse: (sidebarCollapse) =>
        set((_state) => ({ isSidebarCollapse: sidebarCollapse })),
    }),
    {
      name: "app-store", // Name of the item in local storage
      getStorage: () => localStorage, // Use local storage
    }
  )
);

export default useAppStore;
